// ANGULAR
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// SERVICES
import { GlobalService } from '@services/global.service';
// MODELS
import { UpdateCfg, CheckRequest, PostUpdateOracleRequest, CheckRequestError } from '@models/actualizaciones.model';
// RXJS
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActualizacionesService {
  readonly httpOptions: { headers: HttpHeaders, params: HttpParams } = { headers: new HttpHeaders({ 'content-type': 'application/json', 'accept': 'application/json' }), params: new HttpParams() };

  constructor(
    private globalService: GlobalService,
    private http: HttpClient
  ) { }

  getActualizacionesCfg(): Observable<UpdateCfg> {
    return this.http.get<UpdateCfg>(`${this.globalService.apiUrl.url}/Actualizaciones/Cfg`, this.httpOptions);
  }

  putEditActualizacionesCfg(updateCfg: UpdateCfg): Observable<void> {
    return this.http.put<void>(`${this.globalService.apiUrl.url}/Actualizaciones/Cfg`, updateCfg, this.httpOptions);
  }

  postCheck(): Observable<void> { // No se utiliza por eso no se pone modelo, header o query
    return this.http.post<void>(`${this.globalService.apiUrl.url}/Actualizaciones/Check`, null, this.httpOptions);
  }

  getCheckRequests(): Observable<CheckRequest[]> {
    return this.http.get<CheckRequest[]>(`${this.globalService.apiUrl.url}/Actualizaciones/Check/Requests`, this.httpOptions);
  }

  deleteCheckRequests(): Observable<void> {
    return this.http.delete<void>(`${this.globalService.apiUrl.url}/Actualizaciones/Check/Requests`, this.httpOptions);
  }

  deleteCheckRequest(clientId: string): Observable<void> {
    return this.http.delete<void>(`${this.globalService.apiUrl.url}/Actualizaciones/Check/Requests/${clientId}`, this.httpOptions);
  }

  postCheckRequestsPreview(clientId: string, preview: boolean): Observable<void> {
    let params: HttpParams = new HttpParams();
    params = params.set('preview', preview);

    return this.http.post<void>(`${this.globalService.apiUrl.url}/Actualizaciones/Check/Requests/${clientId}/Preview`, null, { ...this.httpOptions, params });
  }

  postVersionDatosOraculo(applicationId: number): Observable<void> { // No se utiliza por eso no se pone modelo, header o query
    return this.http.post<void>(`${this.globalService.apiUrl.url}/Actualizaciones/Aplicaciones/${applicationId}/VersionDatosOraculo`, null, this.httpOptions);
  }

  postActualizarOraculo(postUpdateOracleRequest: PostUpdateOracleRequest): Observable<void> {
    return this.http.post<void>(`${this.globalService.apiUrl.url}/Actualizaciones/Aplicaciones/ActualizarOraculo`, postUpdateOracleRequest, this.httpOptions);
  }

  getErroresCheckRequests(): Observable<CheckRequestError[]> {
    return this.http.get<CheckRequestError[]>(`${this.globalService.apiUrl.url}/Actualizaciones/Errores`, this.httpOptions);
  }

  deleteErroresCheckRequests(): Observable<void> {
    return this.http.delete<void>(`${this.globalService.apiUrl.url}/Actualizaciones/Errores`, this.httpOptions);
  }
}